import React from "react";
import styled from "styled-components";
import { Colors } from "./styles/Colors";
import { ProximaNova } from "./typography";

const Wrapper = styled.div`
  display: flex;

  align-items: center;

  height: 34px;

  margin-bottom: 32px;

  svg {
    margin-right: 18px;
  }

  span {
    position: relative;
    cursor: ${(props) => (props.scrollTo !== null ? "pointer" : "auto")};

    display: block;
    margin-left: 18px;

    font-family: ${ProximaNova};
    font-size: 14px;

    color: ${(props) => props.textColor};

    &::after {
      content: "";

      position: absolute;
      top: 50%;
      left: -18px;

      transform: translateY(-50%);

      height: 34px;
      width: 1px;

      background: ${Colors.webGrey};
    }
  }
`;

export default function RatingStars({ score, count, scrollTo = null, fill = Colors.sage, textColor = Colors.grey }) {
  const filled = {
    fill: fill,
  };

  const outlined = {
    stroke: fill,
    strokeWidth: "0.75",
  };

  return (
    <Wrapper textColor={textColor}>
      <svg
        width="113"
        height="18"
        viewBox="0 0 113 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M103.5 0.725579L106.147 5.10933L106.228 5.24481L106.382 5.28073L111.369 6.44306L108.018 10.3147L107.914 10.4344L107.928 10.592L108.364 15.6941L103.646 13.7032L103.5 13.6417L103.354 13.7032L98.6364 15.6941L99.072 10.592L99.0855 10.4344L98.9819 10.3147L95.6306 6.44306L100.618 5.28073L100.772 5.24481L100.853 5.10933L103.5 0.725579Z"
          {...(score > 4 ? filled : outlined)}
        />
        <path
          d="M81 0L83.9675 4.91552L89.5595 6.21885L85.8016 10.5601L86.2901 16.2812L81 14.0487L75.7099 16.2812L76.1984 10.5601L72.4405 6.21885L78.0325 4.91552L81 0Z"
          fill="#88A392"
          {...(score > 3 ? filled : outlined)}
        />
        <path
          d="M57 0L59.9675 4.91552L65.5595 6.21885L61.8016 10.5601L62.2901 16.2812L57 14.0487L51.7099 16.2812L52.1984 10.5601L48.4405 6.21885L54.0325 4.91552L57 0Z"
          fill="#88A392"
          {...(score > 2 ? filled : outlined)}
        />
        <path
          d="M33 0L35.9675 4.91552L41.5595 6.21885L37.8016 10.5601L38.2901 16.2812L33 14.0487L27.7099 16.2812L28.1984 10.5601L24.4405 6.21885L30.0325 4.91552L33 0Z"
          fill="#88A392"
          {...(score > 1 ? filled : outlined)}
        />
        <path
          d="M9 0L11.9675 4.91552L17.5595 6.21885L13.8016 10.5601L14.2901 16.2812L9 14.0487L3.70993 16.2812L4.19841 10.5601L0.440492 6.21885L6.03245 4.91552L9 0Z"
          fill="#88A392"
          {...(score > 0 ? filled : outlined)}
        />
      </svg>
      {count !== undefined && <span onClick={() => scrollTo ? scrollTo() : null}>{count} reviews</span>}
    </Wrapper>
  );
}
